import React, { useEffect, useState, useMemo } from "react";

//MUI IMPORTS
import {
  Container,
  Typography,
  ListItemIcon,
  Button,
  Tooltip,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import EvStationIcon from "@mui/icons-material/EvStation";
import { Delete } from "@mui/icons-material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import PeopleIcon from "@mui/icons-material/People";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Divider from "@mui/material/Divider";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Comment from "@mui/icons-material/Comment";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PriceChangeIcon from '@mui/icons-material/PriceChange';

//CUSTOM IMPORTS
import Navbar from "../../../../Navbar";
import FormBajaCliente from "../baja/FormBajaCliente";
import FichaCliente from "../../datoscliente/FichaCliente"; // modificamos esto para que no se rompa
import DialogEdicion from "../modificacion/DialogEdicion";
import ModalMotivoInactivo from "../../abmclientes/baja/ModalMotivoInactivo";
import ConfirmDialog from "../../../../ConfirmDialog";
import NuevoReclamo from "../../../../granel/reclamos/NuevoReclamo";
import TabPanel from "../../abmclientes/alta/TabPanel";
import Saldos from "../../datoscliente/Saldos";
import AddPedidosList from "../../pedidos/altapedido/AddPedidosList";
import TitleUploaded from "../../../../TitleUploaded";
import DialogHistorialPrecios from "../../../../lista_precios/granel/lista_precios/historial/DialogHistorialPrecios"
import { getData, putData } from "../../../../../services/library";
import { logEventos } from "../../../../../services/services";
import { fetchPermisos } from "../../../../../services/services";

function Clientes() {
  /* ----------------------------ESTADOS Y REFS-------------------------------  */
  // const navigate = useNavigate();

  //DATA
  const [clientes, setClientes] = useState();
  const [dataCliente, setDataCliente] = useState({});
  const [permisos, setPermisos]=useState();

  //ESTADOS PARA RENDERIZAR
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true); //Estado q mostrará o no la tabla (pantalla inicial) dnd estan los clientes
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [ficha, setFicha] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [baja, setBaja] = useState(false); //Abre formulario
  const [addPedido, setAddPedido] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [marcarActivo, setMarcarActivo] = useState(false);
  const [modalMotivo, setModalMotivo] = useState(false);
  const [addReclamo, setAddReclamo] = useState(false);
  const [opensaldo, setopensaldo] = useState(false);
  const [title, setTitle] = useState(true);
  const [openHistorial, setopenHistorial] = useState(false);
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);
  const [isLoading, setIsLoading] = useState(false); //de la tabla
  const [loadingcircular, setLoadingcircular] = useState(true); //antes
  const sectorUsuario = localStorage.getItem("sector");
  const edicionIlimitada = sectorUsuario === "12" || sectorUsuario === "7" || (sectorUsuario === "5" && localStorage.getItem("role") === "admin");
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
 const [pagination, setPagination] = useState({ //
  pageIndex: 0, // página inicial
  pageSize: 100, // filas por página
});
  

  /* --------------------------- HANDLERS --------------------------------  */

  const handleClickNuevo = () => {
    setAlta(true);
    setTabla(false);
  };

  async function handleClickActivarCliente(e) {
    await putData(
      e,
      "/clientes/" + dataCliente.id,
      {
        activo: 1,
      },
      setNotificacion
    );
  await obtenerclientes();
  }


  /* --------------------------- FETCHS --------------------------------  */
  const obtenerclientesInactivos = async () => {
    setClientes(null); // limpiar clientes para mostrar el circular de carga mientras se obtienen los datos
    setIsLoading(true);
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    try {
      await getData("/clientes", (data) =>
        setClientes(data.filter((c) => c.activo === 0))
      );
    } catch (err) {
      console.error("Error al obtener clientes inactivos:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const obtenerclientes = async () => {
    setClientes(null);
    setIsLoading(true);
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    try {
      await getData("/clientes/activos", setClientes);
    } catch (err) {
      console.error("Error al obtener clientes activos:", err);
    } finally {
      setIsLoading(false);
      setLoadingcircular(false);
    }
  };

  /* --------------------------- EFFECTS --------------------------------  */
  useEffect(() => {
    if (tabla) {
      obtenerclientes();
    }
  }, [tabla]);

  const obtenerPermisos= async () => {
    const permisos = await fetchPermisos();
    setPermisos(permisos.filter(permiso=> permiso.modulo == "pedidos"))
  }

  useEffect(() => {
    obtenerPermisos();

    logEventos(
      "acceso al menú Clientes",
      "Granel",
      "Clientes",
      localStorage.getItem("user"));
  }, []);
  
  // console.log(permisos)


  /* --------------------------- STYLING -----------------------------  */
  const columns = useMemo(
    () => [
      {
        accessorKey: "sisven_id",
        header: "Sisven",
        size: 70,
        enableColumnActions: false,
      },
      {
        accessorKey: "id",
        header: "Cliente",
        size: 70,
        enableColumnActions: false,
      },
      {
        accessorKey: "razon_social_may",
        header: "Razón Social",
        size: 200,
        enableColumnActions: false,
      },
      {
        accessorKey: "localidad",
        header: "Localidad",
        size: 100,
        enableColumnActions: false,
      },
      {
        accessorKey: "cuit",
        header: "Cuit/DNI",
        size: 100,
        enableColumnActions: false,
      },
      {
        accessorKey: "sucursal",
        header: "Sucursal",
        size: 120,
        enableColumnActions: true,
      },
      {
        accessorKey: "empresa",
        header: "Empresa",
        size: 100,
        enableColumnActions: false,
      },
      {
        accessorKey: "condicion",
        header: "Cond. Pago",
        size: 130,
        enableColumnActions: false,
      },
      {
        accessorKey: "segmento",
        header: "Segmento",
        size: 120,
        enableColumnActions: false,
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };
  const initialState = {
    density: "compact",
    showGlobalFilter: true,
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: {
            main: "rgb(255,122,0)",
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: {
            textTransform: "none",
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  /* --------------------------- RENDER -----------------------------  */
  return (
    <div>
      <Navbar />
      {loadingcircular ? (
        <Box display="flex" justifyContent="center" mt={2}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {tabla && !clientes ? (
            <Box display="flex" justifyContent="center" mt={4}>
              <CircularProgress />
            </Box>
          ) : null}
          {tabla && clientes ? (
            <Container maxWidth="xl">
              <Box mt={2} boxShadow={3}>
              <ThemeProvider theme={tableTheme}>
                <MaterialReactTable
                  onPaginationChange={setPagination}
                  autoResetPageIndex={false} //evitar reseteo tara ##388
                  enableColumnResizing
                  columns={columns}
                  data={clientes}
                  enableRowActions
                  initialState={initialState}
                  state={{
                    isLoading: isLoading,pagination
                  }}
                  positionActionsColumn="last"
                  muiTableHeadCellProps={tableHeadCellProps}
                  localization={MRT_Localization_ES}
                  muiTableBodyRowProps={({ row }) => ({
                    onClick: () => {
                      setDataCliente(row.original);
                      setTabla(false);
                      setFicha(true);
                      setTitle(true);
                    },
                    sx: {
                      cursor: "pointer",
                    },
                  })}
                  muiTableBodyCellProps={({ row }) => ({
                    align: "left",
                    sx: {
                      backgroundColor:
                        row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
                      color: "black",
                      borderColor: "black",
                    },
                  })}
                  muiSearchTextFieldProps={muiSearchTextFieldProps}
                  enableDensityToggle={false}
                  layoutMode="grid"
                  renderTopToolbarCustomActions={() => (
                    <>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AddBoxTwoToneIcon color="asd" />}
                        onClick={handleClickNuevo}
                      >
                        Nuevo Cliente
                      </Button>
                      <Typography variant="poster" fontSize={26}>
                        <PeopleIcon sx={{ fontSize: 20 }} />
                        Clientes
                      </Typography>
                    </>
                  )}
                  renderToolbarInternalActions={({ table }) => (
                    <>
                      {!hiddenmuestrainactivo ? (
                        <Tooltip title="Muestra Inactivos">
                          <IconButton
                            onClick={() => obtenerclientesInactivos()}
                            color="error"
                          >
                            <PersonOffIcon />
                          </IconButton>
                        </Tooltip>
                      ) : null}
                      {!hiddenmuestraactivos ? (
                        <Tooltip title="Mostrar ACTIVOS" color="success">
                          <IconButton onClick={() => obtenerclientes()}>
                            <PersonIcon />
                          </IconButton>
                        </Tooltip>
                      ) : null}

                      <MRT_FullScreenToggleButton table={table} />
                    </>
                  )}
                  renderRowActionMenuItems={({ closeMenu, row, index }) => [
                    <MenuItem
                      key={0}
                      style={{
                        display: row.original.activo === 0 ? null : "none",
                      }}
                      disabled={row.original.activo === 1}
                      onClick={() => {
                        closeMenu();
                        setDataCliente(row.original);
                        setMarcarActivo(true);
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <CheckCircleOutlineIcon color="success" />
                      </ListItemIcon>
                      Marcar Activo
                    </MenuItem>,

                    <MenuItem
                      key={1}
                      style={{
                        display: row.original.activo === 0 ? "none" : null,
                      }}
                      disabled={
                        row.original.activo === 0
                      }
                      onClick={() => {
                        closeMenu();
                        setDataCliente(row.original);
                        setEditar(true);
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <BorderColorIcon color="primary" />
                      </ListItemIcon>
                      Editar
                    </MenuItem>,

                    <MenuItem
                      key={2}
                      style={{
                        display: row.original.activo === 0 ? "none" : null,
                      }}
                      disabled={row.original.activo === 0}
                      onClick={() => {
                        closeMenu();
                        setDataCliente(row.original);
                        setBaja(true);
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <Delete color="error" />
                      </ListItemIcon>
                      Marcar Inactivo
                    </MenuItem>,

                    <Divider light />,

                    <MenuItem
                      key={3}
                      style={{
                        display: row.original.activo === 0 ? null : "none",
                      }}
                      disabled={row.original.activo === 1}
                      onClick={() => {
                        closeMenu();
                        setDataCliente(row.original);
                        setModalMotivo(true);
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <Comment color="primary" />
                      </ListItemIcon>
                      Ver Motivo
                    </MenuItem>,

                    <MenuItem
                      key={4}
                      style={{
                        display: row.original.activo === 0 ? "none" : null,
                      }}
                      disabled={row.original.activo === 0}
                      onClick={() => {
                        closeMenu();
                        setDataCliente(row.original);
                        setTabla(false);
                        setFicha(true);
                        setTitle(true);
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <RemoveRedEyeIcon color="success" />
                      </ListItemIcon>
                      Administrar Datos De Cliente
                    </MenuItem>,

                    <MenuItem
                      key={5}
                      style={{
                        display: row.original.activo === 0 ? "none" : null,
                      }}
                      disabled={
                        row.original.activo === 0 || 
                        !permisos.find(permiso=>permiso.funcion == "cargar_pedidos")
                      }
                      onClick={() => {
                        closeMenu();
                        setTabla(false);
                        setAddPedido(true);
                        setDataCliente(row.original);
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <EvStationIcon color="secondary" />
                      </ListItemIcon>
                      Cargar Pedido
                    </MenuItem>,

                    <MenuItem
                      key={6}
                      style={{
                        display: row.original.activo === 0 ? "none" : null,
                      }}
                      disabled={row.original.activo === 0}
                      onClick={() => {
                        closeMenu();
                        setTabla(false);
                        setAddReclamo(true);
                        setDataCliente(row.original);
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <PendingActionsIcon color="error" />
                      </ListItemIcon>
                      Cargar Reclamo
                    </MenuItem>,
                    <Divider light />,
                    <MenuItem
                      key={7}
                      style={{
                        display: row.original.activo === 0 ? "none" : null,
                      }}
                      disabled={row.original.activo === 0}
                      onClick={() => {
                        closeMenu();
                        setTabla(true);
                        setopensaldo(true);
                        setDataCliente(row.original);
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <ReceiptLongIcon color="success" />
                      </ListItemIcon>
                      Visualizar saldos
                    </MenuItem>,
                    <MenuItem
                      key={8}
                      style={{
                        display: row.original.activo === 0 ? "none" : null,
                      }}
                      // disabled={row.original.precio_especial !== 1}
                      onClick={() => {
                        closeMenu();
                        setTabla(true);
                        setopenHistorial(true)
                        setDataCliente(row.original);
                      }}
                      sx={{ m: 0 }}
                    >
                      <ListItemIcon>
                        <PriceChangeIcon color="success" />
                      </ListItemIcon>
                      Historial de precios
                    </MenuItem>,
                  ]}
                />
              </ThemeProvider>
            </Box>
            <br />
            <br />
          </Container>
          ) : null}
        </>
      )}
      {alta ? <TabPanel alta={setAlta} tabla={setTabla} /> : null}

      {baja ? (
        <FormBajaCliente
          open={baja}
          setOpen={setBaja}
          cliente={dataCliente}
          tabla={setTabla}
          actualizar={obtenerclientes}
        />
      ) : null}

      {editar ? (
        <DialogEdicion
          open={editar}
          setOpen={setEditar}
          cliente={dataCliente}
          actualizar={obtenerclientes}
          edicionIlimitada={edicionIlimitada}
        />
      ) : null}

      {ficha ? (
        <FichaCliente
          ficha={setFicha}
          tabla={setTabla}
          datos={dataCliente}
          setDatos={setDataCliente}
          actualizar={obtenerclientes}
          setTitle={setTitle}
          title={title}
          edicionIlimitada={edicionIlimitada}
          permisos={permisos}
        />
      ) : null}

      {addPedido ? (
        <AddPedidosList
          datosCli={dataCliente}
          addPedido={setAddPedido}
          tabla={setTabla}
          actualizar={obtenerclientes}
          setDataCliente={setDataCliente}
          vengo={"TablaCli"}
        />
      ) : null}

      {marcarActivo ? (
        <ConfirmDialog
          open={marcarActivo}
          setOpen={setMarcarActivo}
          title={"Marcar Cliente Activo"}
          text={"Confirme que desea volver a activar este cliente."}
          notificacion={notificacion}
          setNotificacion={setNotificacion}
          guardar={handleClickActivarCliente}
        />
      ) : null}

      {modalMotivo ? (
        <ModalMotivoInactivo
          open={modalMotivo}
          setOpen={setModalMotivo}
          cliente={dataCliente}
        />
      ) : null}

      {addReclamo ? (
        <Container maxWidth="lg">
          <TitleUploaded
            title={`Nuevo Reclamo: ${dataCliente.razon_social}`}
            handleClose={() => {
              setAddReclamo(false);
              setTabla(true);
            }}
          />
          <NuevoReclamo
            dataCliente={dataCliente}
            addReclamo={setAddReclamo}
            tabla={setTabla}
            handleClose={() => {
              setAddReclamo(false);
              setTabla(true);
            }}
          />
        </Container>
      ) : null}

      {opensaldo ? (
        <Saldos
          open={opensaldo}
          setopen={setopensaldo}
          dataCliente={dataCliente}
          setDataCliente={setDataCliente}
          tabla={setTabla}
        />
      ) : null}

      {openHistorial ? (
        <DialogHistorialPrecios
          title={`Historial de Precios: ${dataCliente.razon_social}`}
          open={openHistorial}
          params={dataCliente}
          handleClose={() => {
            setopenHistorial(false);
          }}
        />
      ) : null}
    </div>
  );
}

export default Clientes;
